import { ResourceTypes } from "~/services/resource";
import Trans from "~/types/translationKeys";
import Colors from "./colors";

export const highlightFeatures = [
  {
    title:
      Trans["5_minutes_to_enable_ai_chat_engine_for_both_your_web_and_app"],
    icon: "/svgs/hl_feature_icon_1.svg",
    image: "/svgs/hl_feature_1.svg",
    animation: "/animations/5mins.json",
  },
  {
    title: Trans.hybrid_mode_combine_ai_and_real_human_conversation_at_any_time,
    icon: "/svgs/hl_feature_icon_2.svg",
    image: "/svgs/hl_feature_2.svg",
  },
  {
    title: Trans.auto_study_from_available_data,
    icon: "/svgs/hl_feature_icon_3.svg",
    image: "/svgs/hl_feature_3.svg",
  },
  {
    title:
      Trans.unlimited_free_trial_cancel_anytime_no_commitment_no_data_collected,
    icon: "/svgs/hl_feature_icon_4.svg",
    image: "/svgs/hl_feature_4.svg",
  },
  {
    title: Trans.manage_multi_chat_sessions_labeling,
    icon: "/svgs/hl_feature_icon_5.svg",
    image: "/svgs/hl_feature_5.svg",
  },
];

export const questions = [
  {
    quesiton: 'What does "5000 conversations" mean?',
    answer:
      "You can have up to 5,000 separate chat sessions. Each time a customer starts a chat, it counts as one conversation. If a customer starts a chat but leaves without replying, it still counts as one conversation.",
  },
  {
    quesiton: "What happens if I exceed the message limit in my plan?",
    answer:
      "When your conversation limit is reached, only the AI reply feature will be temporarily paused. All other features will continue to work as usual. If you want the AI to keep responding, you can either upgrade your plan or contact us to purchase extra conversations.",
  },
  {
    quesiton: "Can I create unlimited bot?",
    answer:
      "Yes! With our subscription plan, you can create as many bots as you need - no limit.",
  },
  {
    quesiton: "Will our agents be notified when a customer chats with the bot?",
    answer:
      "Yes, absolutely! Your agents will be notified in real time when someone starts chatting with the bot - with sound alerts included.",
  },
  {
    quesiton: "Can I modify the contact's information of the customer?",
    answer:
      "Yes, you can. Simply go to the Contact List and update the details as needed. If you need help, feel free to book a demo with us!",
  },
  {
    quesiton: "How many workspaces can I create with one account?",
    answer: "There’s no limit - you can create as many workspaces as you need.",
  },
  {
    quesiton: "How do I connect the chatbot to other platforms?",
    answer:
      "Go to Platform Integration in your dashboard, then select the platform you’d like to connect - it only takes a few clicks.",
  },
  {
    quesiton: "If I buy a subscription plan, will it apply to all workspaces?",
    answer:
      "Unfortunately, no. Each subscription plan only applies to one workspace, so you’ll need to purchase a separate plan for each additional workspace.",
  },
  {
    quesiton: "Can I change bot's default reply language?",
    answer:
      "Yes! Just go to your bot settings, open the General Information section, and select your preferred reply language.",
  },
  {
    quesiton: "Which AI model does CX Genie use by default?",
    answer:
      "CX Genie currently uses the ChatGPT-4o model for all chatbots by default.",
  },
  {
    quesiton: "How do I add a team member to my workspace?",
    answer:
      "Go to Settings > Roles & Permissions, then click Add Member to invite a new team member to your workspace.",
  },
  {
    quesiton: "Do CX Genie chatbots support multiple languages?",
    answer:
      "Yes! CX Genie chatbots support nearly 200 languages, so your bot can communicate with customers from all over the world.",
  },
];

export const referralQuestions = [
  {
    quesiton: Trans.how_do_i_become_a_part_of_the_cx_genie_referral_program,
    answer:
      Trans.to_join_our_referral_program_simply_log_into_your_cx_genie_account,
  },
  {
    quesiton:
      Trans.what_are_the_benefits_of_joining_the_cx_genie_referral_program,
    answer:
      Trans.as_a_cx_genie_referral_you_can_earn_significant_commissions_by_referring_new_customers,
  },
  {
    quesiton: Trans.how_does_the_commission_structure_work,
    answer:
      Trans.for_cx_genie_advocates_you_earn_30_of_the_revenue_from_paid_users,
  },
  {
    quesiton: Trans.how_can_i_track_my_referral_performance_and_earnings,
    answer:
      Trans.you_can_track_your_performance_and_earnings_through_the_dedicated_referral_dashboard,
  },
  {
    quesiton:
      Trans.who_should_i_contact_with_any_questions_about_the_referral_program,
    answer:
      Trans.to_get_support_with_the_referral_program_you_can_reach_out_to_us_on_our_cx_genie_discord,
  },
];

export const customerSupportAgentsOptions = [
  {
    label: "< 10",
    value: "<10",
  },
  {
    label: "10 - 50",
    value: "10-50",
  },
  {
    label: "50+",
    value: ">50",
  },
];

export const privacyContent = [
  {
    title: Trans.introduction,
    list: [
      {
        title: Trans.purpose_of_the_privacy_policy,
        content:
          Trans.this_privacy_policy_outlines_our_commitment_to_protecting_your_privacy_and_explains_how_we_collect_use_disclose_and_safeguard_your_data_when_you_use_cx_genie,
      },
      {
        title: Trans.scope_of_the_privacy_policy,
        content:
          Trans.this_policy_applies_to_all_users_of_cx_genie_including_customers_and_visitors_to_our_website,
      },
      {
        title: Trans.consent_and_acceptance,
        content:
          Trans.by_using_cx_genie_you_agree_to_the_terms_of_this_privacy_policy_and_consent_to_the_collection_processing_and_sharing_of_your_information_as_described_in_herein,
      },
    ],
  },
  {
    title: Trans.information_we_collect,
    list: [
      {
        title: Trans.personal_information,
        content:
          Trans.we_collect_personal_information_such_as_your_name_email_address_and_contact_details_when_you_create_an_account_or_communicate_with_us,
      },
      {
        title: Trans.non_personal_information,
        content:
          Trans.we_may_collect_non_personal_information_such_as_device_information_browser_type_and_usage_data_to_improve_our_services,
      },
      {
        title: Trans.cookies_and_tracking_technologies,
        content:
          Trans.we_use_cookies_and_similar_technologies_to_enhance_your_experience_on_cx_genie_and_for_analytics_and_marketing_purposes,
      },
      {
        title: Trans.third_party_data_collection,
        content:
          Trans.we_may_integrate_with_third_party_services_that_collect_data_independently_please_review_the_privacy_policies_of_these_third_parties_for_more_information,
      },
    ],
  },
  {
    title: Trans.how_we_use_your_information,
    list: [
      {
        title: Trans.providing_services,
        content:
          Trans.we_use_your_information_to_provide_and_improve_cx_genie_s_services_including_customer_support_automation_and_engagement_features,
      },
      {
        title: Trans.customer_support_automation,
        content:
          Trans.cx_genie_uses_ai_to_automate_customer_support_processes_your_interactions_with_our_platform_may_be_analyzed_to_improve_the_quality_of_responses,
      },
      {
        title: Trans.personalization_and_customer_engagement,
        content:
          Trans.we_may_use_your_data_to_personalize_your_experiences_and_engage_with_you_through_emails_notifications_or_in_app_messages,
      },
    ],
  },
  {
    title: Trans.sharing_your_information,
    list: [
      {
        title: Trans.third_party_service_providers,
        content:
          Trans.we_may_share_your_data_with_third_party_service_providers_who_assist_us_in_delivering_and_improving_cx_genie_s_services,
      },
      {
        title: Trans.legal_requirements,
        content:
          Trans.we_may_disclose_your_information_if_required_by_law_such_as_in_response_to_a_subpoena_or_other_legal_process,
      },
      {
        title: Trans.business_transfers,
        content:
          Trans.in_the_event_of_a_merger_acquisition_or_sale_of_assets_your_data_may_be_transferred_to_the_new_entity,
      },
      {
        title: Trans.aggregated_or_deidentified_data,
        content:
          Trans.we_may_share_aggregated_or_de_identified_data_for_analytics_and_research_purposes,
      },
    ],
  },
  {
    title: Trans.your_privacy_choices,
    list: [
      {
        title: Trans.accessing_and_updating_your_information,
        content:
          Trans.we_may_share_your_data_with_third_party_service_providers_who_assist_us_in_delivering_and_improving_cx_genie_s_services,
      },
      {
        title: Trans.communication_preferences,
        content:
          Trans.you_can_manage_your_communication_preferences_by_adjusting_settings_within_your_cx_genie_account_or_by_unsubscribing_from_emails,
      },
      {
        title: Trans.cookies_and_tracking,
        content:
          Trans.you_can_manage_cookies_and_tracking_preferences_through_your_browser_settings,
      },
      {
        title: Trans.do_not_track_signals,
        content: Trans.we_do_not_currently_respond_to_do_not_track_signals,
      },
    ],
  },
  {
    title: Trans.data_security,
    list: [
      {
        title: Trans.security_measures,
        content:
          Trans.we_employ_industry_standard_security_measures_to_protect_your_data,
      },
      {
        title: Trans.data_breach_response,
        content:
          Trans.in_the_event_of_a_data_breach_we_will_notify_affected_users_in_accordance_with_applicable_laws,
      },
    ],
  },
  {
    title: Trans.third_party_links_and_services,
    list: [
      {
        title: Trans.external_websites,
        content:
          Trans.cx_genie_may_contain_links_to_external_websites_we_are_not_responsible_for_the_privacy_practices_or_content_of_these_websites,
      },
      {
        title: Trans.integration_with_third_party_services,
        content:
          Trans.cx_genie_may_integrate_with_third_party_services_your_use_of_these_services_is_subject_to_their_respective_privacy_policies,
      },
    ],
  },
  {
    title: Trans.childrens_privacy,
    list: [
      {
        title: Trans.age_restrictions,
        content:
          Trans.cx_genie_is_not_intended_for_children_under_the_age_of_13_we_do_not_knowingly_collect_personal_information_from_children_under_13,
      },
      {
        title: Trans.parental_consent,
        content:
          Trans.if_you_believe_that_we_have_collected_information_from_a_child_under_13_without_parental_consent_please_contact_us_to_request_removal_of_that_information,
      },
    ],
  },
  {
    title: Trans.international_users,
    list: [
      {
        title: Trans.cross_border_data_transfer,
        content:
          Trans.by_using_cx_genie_you_consent_to_the_transfer_of_your_data_to_the_united_states_and_other_jurisdictions_as_necessary_for_the_purposes_outlined_in_this_privacy_policy,
      },
      {
        title: Trans.eu_users_rights_if_applicable,
        content:
          Trans.if_you_are_an_eu_user_you_may_have_additional_rights_under_the_general_data_protection_regulation_gdpr_please_see_our_separate_gdpr_privacy_notice_for_more_information,
      },
    ],
  },
  {
    title: Trans.changes_to_this_privacy_policy,
    list: [
      {
        title: Trans.notification_of_changes,
        content:
          Trans.we_will_notify_you_of_any_material_changes_to_this_privacy_policy_through_the_cx_genie_platform_or_via_email,
      },
      {
        title: Trans.effective_date,
        content:
          Trans.the_effective_date_of_this_privacy_policy_is_indicated_at_the_top_of_the_page,
      },
    ],
  },
  {
    title: Trans.contact_information,
    list: [
      {
        title: Trans.data_controller,
        content: Trans.your_company_name_and_address,
      },
      {
        title: Trans.data_protection_officer,
        content: Trans.name_and_contact_information_of_dpo,
      },
      {
        title: Trans.contact_us,
        content:
          Trans.if_you_have_questions_or_concerns_about_this_privacy_policy_or_your_data_please_contact_us_at,
      },
    ],
  },
  {
    title: Trans.additional_information_if_applicable,
    list: [
      {
        title: Trans.california_privacy_rights,
        content:
          Trans.if_you_are_a_california_resident_you_may_have_additional_rights_under_the_california_consumer_privacy_act_ccpa,
      },
      {
        title: Trans.gdpr_data_subject_rights,
        content:
          Trans.if_you_are_an_eu_user_you_have_certain_rights_under_the_general_data_protection_regulation_gdpr_please_see_our_separate_gdpr_privacy_notice_for_more_information,
      },
    ],
  },
];

export const termsContent = [
  {
    title: Trans.introduction,
    content:
      Trans.thank_you_for_choosing_cx_genie_a_cutting_edge_software_as_a_service_saaS_platform_that_leverages_artificial_intelligence,
  },
  {
    title: Trans.acceptance_of_terms,
    content:
      Trans.by_accessing_or_using_cx_genie_you_agree_to_be_bound_by_these_terms_of_use,
  },
  {
    title: Trans.changes_to_terms,
    content:
      Trans.cx_genie_reserves_the_right_to_modify_these_terms_of_use_at_any_time_we_will_notify_you_of_any_changes,
  },
  {
    title: Trans.user_accounts,
    list: [
      {
        title: Trans.registration,
        content:
          Trans.to_use_cx_genie_you_may_be_required_to_create_a_user_account_you_agree_to,
      },
      {
        title: Trans.access_control,
        content:
          Trans.you_are_responsible_for_all_activities_that_occur_under_your_account_you_agree_not_to_share_your_account_information,
      },
    ],
  },
  {
    title: Trans.use_of_cx_genie,
    list: [
      {
        title: Trans.permitted_use,
        content:
          Trans.you_may_use_cx_genie_for_its_intended_purpose_which_is_to_enhance_customer_support_and_engagement,
      },
      {
        title: Trans.prohitted_activities,
        content:
          Trans.you_agree_not_to_engage_in_any_activities_that_are_illegal_harmful_or_violate_the_rights_of_others_while_using_cx_genie,
      },
    ],
  },
  {
    title: Trans.subscription_and_payment,
    list: [
      {
        title: Trans.subscription_plans,
        content:
          Trans.cx_geni_offers_various_subscription_plans_each_with_its_own_features_and_pricing,
      },
      {
        title: Trans.billing,
        content:
          Trans.payments_are_processed_through_secure_third_party_payment_processors_you_agree_to,
      },
      {
        title: Trans.cancellation,
        content:
          Trans.you_can_cancel_your_subscription_at_any_time_and_your_access_to_cx_genie_will_continue_until_the_end_of,
      },
    ],
  },
  {
    title: Trans.privacy_and_data_security,
    content:
      Trans.cx_genie_takes_your_privacy_and_data_security_seriously_our_privacy_policy_outlines,
  },
  {
    title: Trans.termination_of_service,
    content:
      Trans.cx_genie_reserves_the_right_to_terminate_or_suspend_your_access_to_our_services_at_our_discretion,
  },
  {
    title: Trans.disclaimer_of_warranties,
    content:
      Trans.cx_genie_provides_its_services_as_is_and_as_available_we_make_no_warranties_express_or_implied,
  },
  {
    title: Trans.limitation_of_liability,
    content:
      Trans.cx_genie_shall_not_be_liable_for_any_direct_or_indirect_damages_incidental_to_or_consequential_dames,
  },
  {
    title: Trans.governing_law,
    content:
      Trans.these_terms_of_use_are_governed_by_and_confronted_in_accordance_with_the_laws_of_your_jurisdiction_without_regard_to_its_conflict_of_law_principles,
  },
  {
    title: Trans.contact_us,
    content:
      Trans.if_you_have_any_questions_concerns_or_feedback_regarding_these_terms_of_use_or_our_services_please_contact_us,
  },
];

export const resourceNameByType: Record<ResourceTypes, string> = {
  [ResourceTypes.BLOGS]: Trans.blogs,
  [ResourceTypes.OLD_BLOGS]: Trans.blogs,
  [ResourceTypes.CASE_STUDY]: Trans.case_studies,
  [ResourceTypes.PRODUCT_VIDEOS]: Trans.product_videos,
  [ResourceTypes.RELEASES]: Trans.releases,
};

export const features = [
  {
    icon: "/features/feature_1_icon.svg",
    thumb: "/features/feature_1_thumb.png",
    title: Trans.ai_chatbots_title,
    description: Trans.ai_chatbots_desc,
    url: "/solutions/ai-chatbots",
  },
  {
    icon: "/features/feature_2_icon.svg",
    thumb: "/features/feature_2_thumb.svg",
    title: Trans.workflow_title,
    description: Trans.workflow_desc,
    url: "/solutions/workflow",
  },
  {
    icon: "/features/feature_3_icon.svg",
    thumb: "/features/feature_3_thumb.png",
    title: Trans.ticket_management_title,
    description: Trans.ticket_management_desc,
    url: "/solutions/ticket-management",
  },
  {
    icon: "/features/feature_4_icon.svg",
    thumb: "/features/feature_4_thumb.png",
    title: Trans.whitelabel_title,
    description: Trans.whitelabel_desc,
    url: "/solutions/white-label",
  },
  {
    icon: "/features/feature_5_icon.svg",
    thumb: "/features/feature_5_thumb.png",
    title: Trans.product_data_sync_title,
    description: Trans.product_data_sync_desc,
    url: "/solutions/product-data-sync",
  },
  {
    icon: "/features/feature_6_icon.svg",
    thumb: "/features/feature_6_thumb.png",
    title: Trans.help_desk_title,
    description: Trans.help_desk_desc,
    url: "/solutions/help-desk",
  },
];

export const keyFeatures = [
  {
    icon: "/svgs/key_feature_1.svg",
    name: Trans.key_feature_1_title,
    description: Trans.key_feature_1_desc,
  },
  {
    icon: "/svgs/key_feature_2.svg",
    name: Trans.key_feature_2_title,
    description: Trans.key_feature_2_desc,
  },
  {
    icon: "/svgs/key_feature_3.svg",
    name: Trans.key_feature_3_title,
    description: Trans.key_feature_3_desc,
  },
  {
    icon: "/svgs/key_feature_4.svg",
    name: Trans.key_feature_4_title,
    description: Trans.key_feature_4_desc,
  },
];

export const affiliateBenefits = [
  {
    icon: "/svgs/referral_benefit_1.svg",
    name: Trans.earn_high_commissions,
    description: Trans.earn_high_commissions_description,
  },
  {
    icon: "/svgs/referral_benefit_2.svg",
    name: Trans.offer_exclusive_discount,
    description: Trans.offer_exclusive_discount_description,
  },
  {
    icon: "/svgs/referral_benefit_3.svg",
    name: Trans.promote_cutting_edge_tools,
    description: Trans.promote_cutting_edge_tools_description,
  },
  {
    icon: "/svgs/referral_benefit_4.svg",
    name: Trans.flexible_and_supportive_program,
    description: Trans.flexible_and_supportive_program_description,
  },
];

export const audiences = [
  {
    name: Trans.customer_service_teams,
    description:
      Trans.strugging_with_high_contact_volumes_and_repetitive_inquiries_cx_genie_empowers_you_to_automate_faqs,
  },
  {
    name: Trans.e_commerce_and_retail_businesses,
    description:
      Trans.want_to_engage_customers_provide_real_time_assistance_and_offer_product_recommendations_cx_genie_helps_you,
  },
  {
    name: Trans.marketing_and_sales_teams,
    description:
      Trans.looking_to_improve_lead_generation_qualify_prospects_nurture_relationships_cx_genie_lets_you_capture_valuable_customer_data,
  },
  {
    name: Trans.financial_services,
    description:
      Trans.need_to_provide_personalized_communication_offer_advice_and_streamline_account_management,
  },
  {
    name: Trans.technology_and_software_startups,
    description:
      Trans.want_to_gather_product_feedback_prioritize_feature_requests_and_engage_directly_with_users_cx_genie_allows_you,
  },
];

export const brands = [
  { name: "eastplayers", icon: "/svgs/brand_1.svg", width: 157 },
  { name: "mfast", icon: "/svgs/brand_4.svg", width: 131 },
  { name: "bitjoy", icon: "/svgs/brand_7.svg", width: 101 },
  { name: "agene", icon: "/svgs/brand_2.svg", width: 113 },
  { name: "your ai cheatsheet", icon: "/svgs/brand_3.svg", width: 128 },
  { name: "anawan", icon: "/svgs/brand_5.svg", width: 194 },
  { name: "the frame", icon: "/svgs/brand_6.svg", width: 147 },
];

export const AppsumoTiers = [
  {
    name: Trans.appsumo_license_tire_1,
    price: "$216",
    discounted_price: "$69",
    price_number: 216,
    discounted_priceNumber: 69,
    max_monthly_conversation: 5000,
    max_document: 50,
    max_chatbot: 20,
    max_member: 5,
    tier: 1,
    checkoutName: "[CX Genie] Workspace Lifetime Subscription Tier 1",
    checkoutShortName: "LTD Tier 1",
  },
  {
    name: Trans.appsumo_license_tire_2,
    price: "$264",
    discounted_price: "$169",
    price_number: 264,
    discounted_priceNumber: 169,
    max_monthly_conversation: 25000,
    max_document: -1,
    max_chatbot: 50,
    max_member: 20,
    tier: 2,
    checkoutName: "[CX Genie] Workspace Lifetime Subscription Tier 2",
    checkoutShortName: "LTD Tier 2",
  },
  {
    name: Trans.appsumo_license_tire_3,
    price: "$480",
    discounted_price: "$389",
    price_number: 480,
    discounted_priceNumber: 389,
    max_monthly_conversation: 50000,
    max_document: -1,
    max_chatbot: -1,
    max_member: -1,
    tier: 3,
    checkoutName: "[CX Genie] Workspace Lifetime Subscription Tier 3",
    checkoutShortName: "LTD Tier 3",
  },
];

export const appSumo = {
  name: Trans.life_time_deal,
  origin_price: "$69.0",
  discount_price: "$1,499",
  sub_name: Trans.special_offer_only_on,
  feature_1: [
    Trans["30000_messages_month"],
    Trans["50_documents_for_ai_knowledge_files_faqs_articles_urls"],
    Trans.install_chatbot_on_website_mobile_app,
    Trans.hybrid_chat_mode_for_agent_with_ai_recommendation,
  ],
  feature_2: [
    Trans.max_30_members,
    Trans.usage_reports,
    Trans.api_access,
    Trans.live_chat_technical_support,
    Trans.ai_model_openai_gpt4,
  ],
  terms: [
    Trans[
      "60_day_money_back_guarantee_try_it_out_for_2_months_to_make_sure_it_is_right_for_you"
    ],
    Trans.lifetime_access_to_cx_genie,
    Trans.all_future_updates,
    Trans.all_future_ai_model_updates,
    Trans.if_plan_name_changes_deal_will_be_mapped_to_the_new_plan_name_with_all_accompanied_updates,
    Trans.no_codes_no_stacking_just_choose_the_plan_that_s_right_for_you,
  ],
  conditions: [
    Trans.you_must_activate_your_plan_within_60_days_of_purchase,
    Trans.gdpr_compliant,
  ],
};

export const LanguageOptions = [
  {
    icon: "/svgs/flag_en.svg",
    value: "en",
    label: "English",
    shortLabel: "EN",
  },
  {
    icon: "/svgs/flag_vi.svg",
    value: "vi",
    label: "Vietnamese",
    shortLabel: "VI",
  },
];

export const Services = [
  {
    name: Trans.ai_agent_deployment_and_customization,
    content:
      Trans.we_set_up_and_fine_tune_ai_assistants_to_suit_your_requirements_ensuring_seamless_integration_with_your_existing_workflows,
    image: "/images/our_service_1.png",
  },
  {
    name: Trans.ai_application_development,
    content:
      Trans.our_team_crafts_specialized_applications_using_advanced_ai_technology_precisely_tailored_to_your_specifications_and_business_objectives,
    image: "/images/our_service_2.png",
  },
  {
    name: Trans.ai_consultation_services,
    content:
      Trans.our_expert_consultancy_provide_personalized_ai_consultation_sessions,
    image: "/images/our_service_3.png",
  },
];

export const WorkingProcessStages = [
  {
    name: Trans.deploy_cx_version_to_the_enterprise_server,
    contents: [
      Trans.clarify_requirements_and_customize_features_suitable_for_your_business,
      Trans.finalize_feature_updates_such_as_direct_database_connections_and_learning_from_real_conversations,
    ],
  },
  {
    name: Trans.data_analysis_and_core_ai_engine_development,
    contents: [
      Trans.utilize_client_data_for_ai_training_enriching_the_knowledge_base,
      Trans.develop_the_core_ai_engine_tailored_to_your_business_logic,
    ],
  },
  {
    name: Trans.implement_customization_features,
    contents: [
      Trans.create_and_implement_ai_applications_leading_to_the_core_ai_engine,
      Trans.seamless_integration_with_internal_systems,
      Trans.generate_comprehensive_performance_reports,
    ],
  },
  {
    name: Trans.guide_businesses_to_use_application_and_provide_ongoing_support,
    contents: [
      Trans.gather_weekly_for_feedback_sessions_continuous_enhancements_and_application_refinements,
    ],
  },
  {
    name: Trans.guide_businesses_to_use_application_and_provide_ongoing_support,
    contents: [
      Trans.provide_ongoing_maintenance_and_support_including_regular_updates_and_user_assistance,
    ],
  },
];

export const Features = [
  {
    name: Trans.proven_leaders,
    content:
      Trans.backed_by_a_team_of_builders_and_entrepreneurs_with_a_strong_track_record_of_success_in_tech_companies_,
    image: "/images/feature_1.png",
  },
  {
    name: Trans.ai_expertise,
    content:
      Trans.we_dont_just_provide_ai_we_deliver_a_competitive_advantage_our_custom_ai_solutions_drive_generative_impact_boost_revenue_and_position_you_ahead_of_your_competitors,
    image: "/images/feature_2.png",
  },
  {
    name: Trans.agile_communicative,
    content:
      Trans.were_flexible_collaborators_adapting_to_your_evolving_needs_and_ensuring_clear_communication,
    image: "/images/feature_3.png",
  },
];

export const CaseStudies = [
  {
    image: "/images/case_study_1.png",
    name: Trans.enhanced_and_implemented_an_nlp_model_resulting_in_a_55_boost_in_auditor_efficiency,
    content:
      Trans.the_technical_team_had_reached_an_impasse_when_the_accuracy_of_their_mvp_model_leveled_off,
  },
  {
    image: "/images/case_study_2.png",
    name: Trans.implemented_automation_for_a_startup_s_due_pledge_procedure_resulting_in_a_25_improvement_in_efficiency,
    content:
      Trans.they_depended_on_a_manual_approach_for_gathering_security_survey_data,
  },
  {
    image: "/images/case_study_3.png",
    name: Trans.implemented_nlp_based_automation_for_a_security_compliance_startup_s_due_pledge_process,
    content:
      Trans.the_company_faced_challenges_in_automating_the_identification_of_business_expenses_and_categorizing,
  },
  {
    image: "/images/case_study_4.png",
    name: Trans.developed_and_implemented_a_strategy_to_launch_a_financial_platform_from_inception_to_initial_development,
    content:
      Trans.the_company_aimed_to_automate_a_labor_intensive_process_of_categorizing_transactions_as_either_personal_or_business_expenses,
  },
];

export const discordBenefits = [
  {
    name: "Faster Support",
    content: "Get real-time support and insights.",
  },
  {
    name: "Instant updates",
    content: "Get tips, new features & promos from CX Genie.",
  },
  {
    name: "AI business community",
    content: "Learn and connect with experts using AI for business",
  },
  {
    name: "Unlock exclusives",
    content: "Get early access to new features and add-ons for free.",
  },
];

export const customerFeedbacks = [
  {
    avatar: "/images/client_8.png",
    name: "Tony_Upbase",
    title: "Powerful AI assistant with mobile app & easy handover",
    description:
      "I purchased CX Genie, and overall, I think it's a well-rounded AI assistant platform.<br/><br/>The integration with Facebook Messenger is quick and easy. Customers can directly interact with the bot within Messenger. The CX Genie also has a mobile app which adds convenience, as the support team can receive notifications on the go.<br/><br/>The AI to Human handover feature is something I was looking for and here its done in a very simple way. CX Genie automatically sends a notification to a human agent when there is a complex question that it doesn't have the answer to, or a message flow can be created to trigger a human agent. Theres a smooth transition from AI to human assistance when needed.<br/><br/>Overall, CX Genie offers excellent value for its price, and I appreciate the ongoing updates and improvements from the CX Genie team.",
    star: 5,
  },
  {
    avatar: "/images/client_1.png",
    name: "natasha00",
    title: "The more I train it, the better it gets. Highly recommend!",
    description:
      "CX Genie is beneficial! The real magic happens when you invest time building the chatbot's knowledge base. The more you feed it with answers to common questions, the better it responds to customer inquiries. This has significantly reduced my time on repetitive customer interactions, freeing me to focus on other issues. Highly recommend!",
    star: 5,
  },
  {
    avatar: "/images/client_2.png",
    name: "ljs.graphics1",
    title: "The mobile app and live chat is Amazing",
    description:
      "Overall, this tool is exceptionally strong. Its responsiveness is impressive, and the seamless transition to live chat handover enhances the user experience. The auto-training feature, leveraging previous conversations, is a standout feature, offering unparalleled efficiency.",
    star: 5,
  },
  {
    avatar: "/images/client_3.png",
    name: "jass_",
    title: "Great  product overall",
    description:
      "This tool is very good overall. Responds well, human handover is awesome, auto-training with previous conversations is fantastic.",
    star: 5,
  },
  {
    avatar: "/images/client_4.png",
    name: "seb_",
    title: "Works really great!",
    description:
      "I love how easy it was to set it up and train. Click here, click there - ready. Discord is alive and full of support from the CX Genie team.",
    star: 5,
  },
  {
    avatar: "/images/client_5.png",
    name: "Waldemar_Ramos",
    title:
      "This chatbot replaces more than 6 software and provides the entire customer service operation",
    description:
      "At the time of writing this review, the CX Genie needs some tweaking and fine-tuning, however, it has already proven to be a fantastic tool that will greatly help my operation.<br/><br/>I'm replacing several complex software and server expenses, such as: Flowise, Botpress, Typebot, N8N, VPS, GPT 4, among others, with just one software that does all this integrated and easy without any code.<br/><br/>Another important point for my evaluation is the attention and quick feedback given by the developers. The support is excellent and they welcome our suggestions for improvements. I recommend that they remain that way.<br/><br/>I'm excited about the upcoming product updates and see potential for it to be the best AI-powered LLM and support tool for sure.",
    star: 5,
  },
  {
    avatar: "/images/client_6.png",
    name: "apps007",
    title: "Lots of potential",
    description:
      "They seem to be focusing on functionality that a lot of bots haven't begun to think about as yet:<br/>1. Seamless integration between human agents and AI agents.<br/>2. Educating the AI based on human agents input.<br/>3. Workflows to enhance how the bot interacts with people.<br/><br/>There are still some bugs here and there but on the whole it's a usable product with a lot of potential.",
    star: 4,
  },
  {
    avatar: "/images/client_7.png",
    name: "onecup",
    title: "Amazing Platform",
    description:
      "This platform is a game-changer. It's incredibly well-designed, and it's evident that the developers know exactly what they're doing. I'm thrilled to have it.",
    star: 5,
  },
  {
    avatar: "/images/client_9.png",
    name: "info9927k",
    title: "Actively being developed",
    description:
      "CX Genie has a solid base and is being developed be a very good support team. They also take every bit of feedback on board in the discord channel. My only concern with the Tier 3 plan was the lack of white labelling for unlimited bots was pointless but Ethan assured me that they are going to review that decision at the end of June.",
    star: 5,
  },
  {
    avatar: "/images/client_10.png",
    name: "dinnoleon",
    title: "The Cochinita Pibil of chatbots",
    description:
      "5 tacos calientes for CX Genie. The feature set is extensive, and the interface is intuitive, so I had no trouble finding my way around and making good use of its capabilities. On top of that, CX Genie's analytics and insights have been crucial in empowering me to make data-driven decisions that have improved our customer experience. On the whole, CX Genie has exceeded my expectations, and I would suggest it to anybody seeking to improve their customer service processes.",
    star: 5,
  },
  {
    avatar: "/images/client_13.png",
    name: "Sebastian C",
    title: "Highly recommended product!",
    description:
      "We’ve successfully implemented CX Genie has become ouras our primary support solution for multiple products. It helped us solve around 60% of support cases without human assistance. The platform offers plenty of teaching methods, access to custom data sets, forms, and many other features that are constantly added and improved. Highly recommended product!",
    star: 5,
  },
  {
    avatar: "/images/client_14.png",
    name: "Viktor S",
    title: "You are my painkiller!",
    description:
      "It’s the exact functionality I’ve been looking for! You are my painkiller! Seriously, thank you and Product Hunt for matching us! I’ve been searching for months, and all other tools were okay, but they always missed something.",
    star: 5,
  },
];

export const lifetimeCustomerFeedbacks = [
  {
    avatar: "/images/client_1.png",
    name: "natasha00",
    title: "The more I train it, the better it gets. Highly recommend!",
    description:
      "CX Genie is beneficial! The real magic happens when you invest time building the chatbot's knowledge base. The more you feed it with answers to common questions, the better it responds to customer inquiries. This has significantly reduced my time on repetitive customer interactions, freeing me to focus on other issues. Highly recommend!",
    star: 5,
  },
  {
    avatar: "/images/client_5.png",
    name: "Waldemar_Ramos",
    title:
      "This chatbot replaces more than 6 software and provides the entire customer service operation",
    description:
      "At the time of writing this review, the CX Genie needs some tweaking and fine-tuning, however, it has already proven to be a fantastic tool that will greatly help my operation.<br/><br/>I'm replacing several complex software and server expenses, such as: Flowise, Botpress, Typebot, N8N, VPS, GPT 4, among others, with just one software that does all this integrated and easy without any code.<br/><br/>Another important point for my evaluation is the attention and quick feedback given by the developers. The support is excellent and they welcome our suggestions for improvements. I recommend that they remain that way.<br/><br/>I'm excited about the upcoming product updates and see potential for it to be the best AI-powered LLM and support tool for sure.",
    star: 5,
  },
  {
    avatar: "/images/client_1.png",
    name: "COO of MFast",
    title: "",
    description:
      "CX Genie has been a game-changer for us at MFast. With the AI-powered chatbots handling routine inquiries, we saw a 40% increase in team efficiency, allowing our agents to focus on more complex customer needs.\n\nIn just a short time, the chatbot served over 100,000 customers quickly and accurately, reducing wait times and improving the overall customer experience.",
    star: 5,
  },
  {
    avatar: "/images/client_8.png",
    name: "Tony_Upbase",
    title: "Powerful AI assistant with mobile app & easy handover",
    description:
      "I purchased CX Genie, and overall, I think it's a well-rounded AI assistant platform.<br/><br/>The integration with Facebook Messenger is quick and easy. Customers can directly interact with the bot within Messenger. The CX Genie also has a mobile app which adds convenience, as the support team can receive notifications on the go.<br/><br/>The AI to Human handover feature is something I was looking for and here its done in a very simple way. CX Genie automatically sends a notification to a human agent when there is a complex question that it doesn't have the answer to, or a message flow can be created to trigger a human agent. Theres a smooth transition from AI to human assistance when needed.<br/><br/>Overall, CX Genie offers excellent value for its price, and I appreciate the ongoing updates and improvements from the CX Genie team.",
    star: 5,
  },
  {
    avatar: "/images/client_13.png",
    name: "Sebastian C",
    title: "Highly recommended product!",
    description:
      "We’ve successfully implemented CX Genie has become ouras our primary support solution for multiple products. It helped us solve around 60% of support cases without human assistance. The platform offers plenty of teaching methods, access to custom data sets, forms, and many other features that are constantly added and improved. Highly recommended product!",
    star: 5,
  },
  {
    avatar: "/images/client_14.png",
    name: "Viktor S",
    title: "You are my painkiller!",
    description:
      "It’s the exact functionality I’ve been looking for! You are my painkiller! Seriously, thank you and Product Hunt for matching us! I’ve been searching for months, and all other tools were okay, but they always missed something.",
    star: 5,
  },
];

export const SolutionsHeader = [
  {
    icon: "chatbot",
    title: Trans.ai_chatbots_title,
    desc: Trans.ai_chatbots_desc,
    url: "/solutions/ai-chatbots",
    color: Colors.ACCENT_GREEN,
  },
  {
    icon: "user-square",
    title: Trans.help_desk_title,
    desc: Trans.help_desk_desc,
    url: "/solutions/help-desk",
    color: Colors.ACCENT_VIOLET,
  },
  {
    icon: "hierarchy-3",
    title: Trans.workflow_title,
    desc: Trans.workflow_desc,
    url: "/solutions/workflow",
    color: Colors.ACCENT_ORANGE,
  },
  {
    icon: "d-cube-scan",
    title: Trans.product_data_sync_title,
    desc: Trans.product_data_sync_desc,
    url: "/solutions/product-data-sync",
    color: Colors.ACCENT_PINK,
  },
  {
    icon: "tag",
    title: Trans.ticket_management_title,
    desc: Trans.ticket_management_desc,
    url: "/solutions/ticket-management",
    color: Colors.ACCENT_BLUE,
  },
  {
    icon: "global-edit",
    title: Trans.whitelabel_title,
    desc: Trans.whitelabel_desc,
    url: "/solutions/white-label",
    color: Colors.ACCENT_YELLOW,
  },
];

export const SolutionDetailData = {
  "ai-chatbots": {
    name: Trans.ai_chatbots_title,
    hero: {
      tag: Trans.ai_chatbots_title,
      title: Trans.revolutionize_customer_engagement_with_ai_powered_chatbots,
      img: "/solutions/ai_chatbots_hero.png",
    },
    description: [
      Trans.enhance_your_customers_engagement_and_satisfaction_with_cxgenies_ai_chatbots,
      Trans.cxgenie_expertly_handles_complex_queries_asks_clarifying_questions_and_engages_in_meaningful_conversations,
    ],
    key_features: [
      {
        icon: "/solutions/ai_chatbots_feature_1.svg",
        name: Trans.intelligent_conversational_ai,
        items: [
          Trans.human_like_interactions_engage_your_customers_with_natural_human_like_conversations_that_feel_more_personal_and_less_robotic,
          Trans.contextual_understanding_leverage_advanced_natural_language_processing_nlp_to_understand_customer_intent,
        ],
      },
      {
        icon: "/solutions/ai_chatbots_feature_2.svg",
        name: Trans.multi_source_responses,
        items: [
          Trans.knowledge_base_integration_pull_information_from_your_existing_knowledge_base,
          Trans.external_data_access_connect_your_chatbot_to_external_databases_and_URLs_to_retrieve_real_time_information,
        ],
      },
      {
        icon: "/solutions/ai_chatbots_feature_3.svg",
        name: Trans.seamless_handoff,
        items: [
          Trans.hybrid_support_model_automatically_escalate_complex_issues_to_human_agents_when_necessary_ensuring_that_customers_always_receive_the_best_possible_service,
          Trans.integrated_support_maintain_a_seamless_transition_between_chatbot_and_human_support_with_full_context,
        ],
      },
      {
        icon: "/solutions/ai_chatbots_feature_4.svg",
        name: Trans.continuous_improvement,
        items: [
          Trans.learning_from_conversations_monitor_and_analyze_chatbot_interactions_to_identify_areas_for_improvement_use,
          Trans.feedback_integration_collect_feedback_directly_from_customers_after_chatbot_interactions_allowing_for_ongoing_optimization_of_your_support_processes,
        ],
      },
      {
        icon: "/solutions/ai_chatbots_feature_5.svg",
        name: Trans.multilingual_capabilities,
        items: [
          Trans.global_reach_support_customers_across_the_globe_with_automatic_language_detection,
          Trans.localized_responses_customize_responses_to_reflect_local_cultural_nuances_and_preferences_enhancing_the_customer_experience_in_different_regions,
        ],
      },
      {
        icon: "/solutions/ai_chatbots_feature_6.svg",
        name: Trans.omni_channel_support,
        items: [
          Trans.unified_interaction_deploy_your_chatbot_across_multiple_channels,
          Trans.cross_platform_ntegration_seamlessly_integrate_your_chatbot_with_popular_platforms,
        ],
      },
    ],
    show_meet_cx_genie: true,
    use_cases: [
      {
        title: Trans.customer_support_title_24_7,
        description: Trans.customer_support_description_24_7,
      },
      {
        title: Trans.lead_qualification_title,
        description: Trans.lead_qualification_description,
      },
      {
        title: Trans.e_commerce_assistance_title,
        description: Trans.e_commerce_assistance_description,
      },
    ],
  },
  workflow: {
    name: Trans.workflow_title,
    hero: {
      tag: Trans.workflow_title,
      title: Trans.streamline_your_customer_interactions_with_dynamic_workflows,
      img: "/solutions/workflow_hero.png",
    },
    description: [Trans.workflow_description],
    key_features: [
      {
        icon: "/solutions/workflow_feature_1.svg",
        name: [Trans.visual_flow_builder],
        items: [
          Trans.feature_visual_flow_builder_description_1,
          Trans.feature_visual_flow_builder_description_2,
        ],
      },
      {
        icon: "/solutions/workflow_feature_2.svg",
        name: Trans.personalized_responses,
        items: [
          Trans.feature_personalized_responses_description_1,
          Trans.feature_personalized_responses_description_2,
        ],
      },
      {
        icon: "/solutions/workflow_feature_3.svg",
        name: Trans.seamless_integration,
        items: [
          Trans.feature_seamless_integration_description_1,
          Trans.feature_seamless_integration_description_2,
        ],
      },
      {
        icon: "/solutions/workflow_feature_4.svg",
        name: Trans.real_time_feedback,
        items: [
          Trans.feature_real_time_feedback_description_1,
          Trans.feature_real_time_feedback_description_2,
        ],
      },
      {
        icon: "/solutions/workflow_feature_5.svg",
        name: Trans.analytics_insights,
        items: [
          Trans.feature_analytics_insights_description_1,
          Trans.feature_analytics_insights_description_2,
        ],
      },
    ],
    show_meet_cx_genie: false,
    use_cases: [
      {
        title: Trans.use_case_customer_onboarding_title,
        description: Trans.use_case_customer_onboarding_description,
      },
      {
        title: Trans.use_case_lead_qualification_title,
        description: Trans.use_case_lead_qualification_description,
      },
      {
        title: Trans.use_case_support_escalation_title,
        description: Trans.use_case_support_escalation_description,
      },
    ],
  },
  "ticket-management": {
    name: Trans.ticket_management_title,
    hero: {
      tag: Trans.ticket_management_title,
      title:
        Trans.efficiently_handle_customer_queries_with_advanced_ticket_management,
      img: "/solutions/ticket_hero.png",
    },
    description: [Trans.ticket_management_description],
    key_features: [
      {
        icon: "/solutions/ticket_feature_1.svg",
        name: Trans.automated_ticket_routing,
        items: [
          Trans.feature_automated_ticket_routing_description_1,
          Trans.feature_automated_ticket_routing_description_2,
        ],
      },
      {
        icon: "/solutions/ticket_feature_2.svg",
        name: Trans.personalized_responses,
        items: [
          Trans.feature_personalized_responses_description_3,
          Trans.feature_personalized_responses_description_4,
        ],
      },
      {
        icon: "/solutions/ticket_feature_3.svg",
        name: Trans.prioritization_slas,
        items: [
          Trans.feature_prioritization_slas_description_1,
          Trans.feature_prioritization_slas_description_2,
        ],
      },
      {
        icon: "/solutions/ticket_feature_4.svg",
        name: Trans.collaborative_support,
        items: [
          Trans.feature_collaborative_support_description_1,
          Trans.feature_collaborative_support_description_2,
        ],
      },
      {
        icon: "/solutions/ticket_feature_5.svg",
        name: Trans.customer_communication_history,
        items: [
          Trans.feature_communication_history_description_1,
          Trans.feature_communication_history_description_2,
        ],
      },
    ],
    show_meet_cx_genie: false,
    use_cases: [
      {
        title: Trans.use_case_incident_management_title,
        description: Trans.use_case_incident_management_description,
      },
      {
        title: Trans.use_case_customer_feedback_title,
        description: Trans.use_case_customer_feedback_description,
      },
      {
        title: Trans.use_case_internal_support_title,
        description: Trans.use_case_internal_support_description,
      },
    ],
    ltd: {
      title: Trans.ltd_feature_1_title,
      subtitle: Trans.ltd_subtitle,
      price: "/solutions/ticket_ltd_price.svg",
      link: "https://buy.stripe.com/00g7uD7nV6o4gfe5kn",
      features: [
        {
          icon: "/solutions/ticket_ltd_1.svg",
          title: Trans.ltd_feature_1_title,
          desc: Trans.ltd_feature_1_description,
        },
        {
          icon: "/solutions/ticket_ltd_2.svg",
          title: Trans.ltd_feature_2_title,
          desc: Trans.ltd_feature_2_description,
        },
        {
          icon: "/solutions/ticket_ltd_3.svg",
          title: Trans.ltd_feature_3_title,
          desc: Trans.ltd_feature_3_description,
        },
      ],
    },
  },
  "help-desk": {
    name: Trans.help_desk_title,
    hero: {
      tag: Trans.help_desk_title,
      title: Trans.help_desk_title_2,
      img: "/solutions/help_desk_hero.png",
    },
    description: [Trans.help_desk_description_1, Trans.help_desk_description_2],
    key_features: [
      {
        icon: "/solutions/help_desk_feature_1.svg",
        name: Trans.agent_management,
        items: [
          Trans.feature_agent_management_description_1,
          Trans.feature_agent_management_description_2,
        ],
      },
      {
        icon: "/solutions/help_desk_feature_2.svg",
        name: Trans.task_assignment,
        items: [
          Trans.feature_task_management_description_1,
          Trans.feature_task_management_description_2,
        ],
      },
      {
        icon: "/solutions/help_desk_feature_3.svg",
        name: Trans.comprehensive_ticket_tracking,
        items: [
          Trans.feature_ticket_tracking_description_1,
          Trans.feature_ticket_tracking_description_2,
        ],
      },
      {
        icon: "/solutions/help_desk_feature_4.svg",
        name: Trans.knowledge_base_integration,
        items: [
          Trans.feature_knowledge_base_description_1,
          Trans.feature_knowledge_base_description_2,
        ],
      },
      {
        icon: "/solutions/help_desk_feature_5.svg",
        name: Trans.customer_self_service,
        items: [
          Trans.feature_customer_self_service_description_1,
          Trans.feature_customer_self_service_description_2,
        ],
      },
    ],
    show_meet_cx_genie: false,
    use_cases: [
      {
        title: Trans.use_case_multi_department_support_title,
        description: Trans.use_case_multi_department_support_description,
      },
      {
        title: Trans.use_case_customer_retention_title,
        description: Trans.use_case_customer_retention_description,
      },
      {
        title: Trans.use_case_proactive_support_title,
        description: Trans.use_case_proactive_support_description,
      },
    ],
    ltd: {
      title: Trans.ltd_title,
      subtitle: Trans.ltd_subtitle_help_desk,
      price: "/solutions/help_desk_ltd_price.svg",
      link: "https://buy.stripe.com/4gw4ir37FeUA0ggbIM",
      features: [
        {
          icon: "/solutions/help_desk_ltd_1.svg",
          title: Trans.ltd_feature_one_time_payment_life_time_value_title,
          desc: Trans.ltd_feature_one_time_payment_life_time_value_description,
        },
        {
          icon: "/solutions/help_desk_ltd_2.svg",
          title: Trans.ltd_feature_empower_your_team_title,
          desc: Trans.ltd_feature_empower_your_team_description,
        },
        {
          icon: "/solutions/help_desk_ltd_3.svg",
          title: Trans.ltd_feature_scalable_for_the_future_title,
          desc: Trans.ltd_feature_scalable_for_the_future_description,
        },
      ],
    },
  },
  "product-data-sync": {
    name: Trans.product_data_sync_title,
    hero: {
      tag: Trans.product_data_sync_title,
      title: Trans.product_data_sync_title_2,
      img: "/solutions/pds_hero.png",
    },
    description: [Trans.product_data_sync_description_1],
    key_features: [
      {
        icon: "/solutions/pds_feature_1.svg",
        name: Trans.automatic_data_syncing,
        items: [
          Trans.feature_automatic_data_syncing_description_1,
          Trans.feature_automatic_data_syncing_description_2,
        ],
      },
      {
        icon: "/solutions/pds_feature_2.svg",
        name: Trans.cross_platform_integration,
        items: [
          Trans.feature_cross_platform_integration_description_1,
          Trans.feature_cross_platform_integration_description_2,
        ],
      },
      {
        icon: "/solutions/pds_feature_3.svg",
        name: Trans.real_time_updates,
        items: [
          Trans.feature_real_time_updates_description_1,
          Trans.feature_real_time_updates_description_2,
        ],
      },
      {
        icon: "/solutions/pds_feature_4.svg",
        name: Trans.centralized_management,
        items: [
          Trans.feature_centralized_management_description_1,
          Trans.feature_centralized_management_description_2,
        ],
      },
      {
        icon: "/solutions/pds_feature_5.svg",
        name: Trans.data_accuracy_assurance,
        items: [
          Trans.feature_data_accuracy_assurance_description_1,
          Trans.feature_data_accuracy_assurance_description_2,
        ],
      },
    ],
    show_meet_cx_genie: false,
    use_cases: [
      {
        title: Trans.use_case_multi_channel_retailing_title,
        description: Trans.use_case_multi_channel_retailing_description,
      },
      {
        title: Trans.use_case_global_ecommerce_operations_title,
        description: Trans.use_case_global_ecommerce_operations_description,
      },
      {
        title: Trans.use_case_seasonal_product_launches_title,
        description: Trans.use_case_seasonal_product_launches_description,
      },
    ],
    ltd: {
      title: Trans.ltd_title,
      subtitle: Trans.ltd_subtitle_product_data_sync,
      price: "/solutions/pds_ltd_price.svg",
      link: "https://buy.stripe.com/7sI3enfUreUA1kkaEJ",
      special_title: Trans.ltd_special_title_product_data_sync,
      features: [
        {
          icon: "/solutions/pds_ltd_1.svg",
          title: Trans.ltd_feature_effortless_integration_title,
          desc: Trans.ltd_feature_effortless_integration_description,
        },
        {
          icon: "/solutions/pds_ltd_2.svg",
          title: Trans.ltd_feature_smarter_support_always_title,
          desc: Trans.ltd_feature_effortless_integration_description,
        },
        {
          icon: "/solutions/pds_ltd_3.svg",
          title: Trans.ltd_feature_pay_once_grow_forever_title,
          desc: Trans.ltd_feature_pay_once_grow_forever_description,
        },
      ],
    },
  },
  "white-label": {
    name: Trans.whitelabel,
    hero: {
      tag: Trans.whitelabel_title,
      title: Trans.white_label_title_2,
      img: "/solutions/white_label_hero.png",
    },
    description: [Trans.white_label_description_1],
    key_features: [
      {
        icon: "/solutions/white_label_feature_1.svg",
        name: Trans.custom_branding,
        items: [
          Trans.feature_custom_branding_description_1,
          Trans.feature_custom_branding_description_2,
        ],
      },
      {
        icon: "/solutions/white_label_feature_2.svg",
        name: Trans.client_specific_workspaces,
        items: [
          Trans.feature_client_specific_workspaces_description_1,
          Trans.feature_client_specific_workspaces_description_2,
        ],
      },
      {
        icon: "/solutions/white_label_feature_3.svg",
        name: Trans.multi_client_management,
        items: [
          Trans.feature_multi_client_management_description_1,
          Trans.feature_multi_client_management_description_2,
        ],
      },
      {
        icon: "/solutions/white_label_feature_4.svg",
        name: Trans.flexible_customization,
        items: [
          Trans.feature_flexible_customization_description_1,
          Trans.feature_flexible_customization_description_2,
        ],
      },
      {
        icon: "/solutions/white_label_feature_5.svg",
        name: Trans.client_reporting,
        items: [
          Trans.feature_client_reporting_description_1,
          Trans.feature_client_reporting_description_2,
        ],
      },
    ],
    show_meet_cx_genie: false,
    is_bright_color: true,
    use_cases: [
      {
        title: Trans.use_case_full_service_agency_title,
        description: Trans.use_case_full_service_agency_description,
      },
      {
        title: Trans.use_case_niche_market_solution_title,
        description: Trans.use_case_niche_market_solution_description,
      },
      {
        title: Trans.use_case_client_retention_title,
        description: Trans.use_case_client_retention_description,
      },
    ],
    ltd: {
      title: Trans.ltd_title,
      subtitle: Trans.ltd_subtitle_white_label,
      price: "/solutions/white_label_ltd_price.svg",
      link: "https://buy.stripe.com/8wM9CL8rZ7s81kk006",
      special_title: Trans.ltd_special_title_white_label,
      features: [
        {
          icon: "/solutions/white_label_ltd_1.svg",
          title: Trans.ltd_feature_boost_client_trust_title,
          desc: Trans.ltd_feature_boost_client_trust_description,
        },
        {
          icon: "/solutions/white_label_ltd_2.svg",
          title: Trans.ltd_feature_create_new_revenue_streams_title,
          desc: Trans.ltd_feature_create_new_revenue_streams_description,
        },
        {
          icon: "/solutions/white_label_ltd_3.svg",
          title: Trans.ltd_feature_pay_once_grow_forever_title,
          desc: Trans.ltd_feature_pay_once_grow_forever_white_label_description,
        },
      ],
    },
  },
};

export const lifetimeQuestions = [
  {
    question: Trans.is_the_lifetime_deal_a_one_time_payment,
    answer:
      Trans.yes_you_pay_once_for_lifetime_access_with_no_recurring_fees_this_includes_all_future_pro_plan_updates,
  },
  {
    question: Trans.what_happens_after_i_purchase_the_ltd,
    answer:
      Trans.youll_get_immediate_lifetime_access_to_cx_genie_and_all_future_pro_plan_updates_will_be_included,
  },
  {
    question: Trans.can_i_upgrade_or_downgrade_between_tiers,
    answer:
      Trans.yes_you_can_upgrade_or_downgrade_between_the_3_license_tiers_while_the_deal_is_active_and_within_60_days_of_purchase,
  },
  {
    question: Trans.is_there_a_refund_policy,
    answer:
      Trans.yes_you_have_a_60_day_money_back_guarantee_try_cx_genie_risk_free_for_2_months,
  },
  {
    question: Trans.does_the_lifetime_deal_include_future_updates,
    answer:
      Trans.absolutely_with_this_deal_you_get_lifetime_access_to_all_future_pro_plan_updates_and_features,
  },
  {
    question: Trans.do_i_need_any_technical_skills_to_set_up_and_use_cx_genie,
    answer:
      Trans.no_cx_genie_is_designed_to_be_user_friendly_and_requires_no_coding_or_technical_expertise_you_can_easily_set_up_ai_bots_workflows_and_integrations_in_minutes,
  },
  {
    question: Trans.what_platforms_does_cx_genie_integrate_with,
    answer:
      Trans.cx_genie_integrates_with_a_wide_range_of_platforms_including_cr_ms_social_media_apps_messaging_apps_and_more,
  },
  {
    question: Trans.how_long_will_the_lifetime_deal_be_available,
    answer:
      Trans.this_is_a_limited_time_offer_and_wont_be_available_forever_be_sure_to_secure_your_lifetime_access_before_the_deal_expires,
  },
  {
    question: Trans.how_does_the_workflow_automation_feature_work,
    answer:
      Trans.cx_genie_s_workflow_automation_allows_you_to_set_up_triggers_and_actions_based_on_customer_or_agent_behavio,
  },
  {
    question: Trans.what_support_can_i_get,
    answer:
      Trans.all_cx_genie_customers_can_get_access_to_our_support_tram_via_discord,
  },
  {
    question: Trans.can_i_still_access_future_add_ons_and_features_with_the_ltd,
    answer:
      Trans.yes_your_lifetime_deal_includes_all_future_feature_updates_however_certain_add_ons_may_be_offered_as_separate_purchases,
  },
];
